import {
    CircularProgress,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import SortAsc from '../../assets/images/llantas/table/sort-asc.svg';
import SortDesc from '../../assets/images/llantas/table/sort-desc.svg';
import Sort from '../../assets/images/llantas/table/sort.svg';
import Security from '../../commons/security/Security.js';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles';
import * as Utils from '../../commons/utils/Utils';
import ProgramasPreventivosGridFiltros from './ProgramasPreventivosGridFiltros.jsx';
import ProgramasPreventivosGridRow from './ProgramasPreventivosGridRow.jsx';

const PAGINATION_INIT = { page: 0, perPage: 10 };

const FILTER_QUERY_INIT = { nombre: '', estado: '', fechaDesde: '', fechaHasta: '' };

const SORT_QUERY_INIT = { nombre: '', fechaInicio: '', updatedAt: '' };

const ProgramasPreventivosGrid = (props) => {
    const intl = useIntl();

    const permissions = {
        visualizar: Security.hasPermission('PROGRAMAS_PREVENTIVOS_VISUALIZAR'),
        eliminar: Security.hasPermission('PROGRAMAS_PREVENTIVOS_ELIMINAR'),
        editar: Security.hasPermission('PROGRAMAS_PREVENTIVOS_EDITAR'),
    };

    const [loading, setLoading] = useState(false);
    const [redirectTo, setRedirectTo] = useState(null);
    const [programas, setProgramas] = useState([]);
    const [paginationCount, setPaginationCount] = useState(0);

    const [pagination, setPagination] = useState({ ...PAGINATION_INIT });
    const [sortQuery, setSortQuery] = useState({ ...SORT_QUERY_INIT });
    const [filterQuery, setFilterQuery] = useState({ ...FILTER_QUERY_INIT });
    const [filterResetInputs, setFilterResetInputs] = useState(false);
    const [dropdownActive, setDropdownActive] = useState(false);

    useEffect(() => {
        if (Security.hasPermission('PROGRAMAS_PREVENTIVOS_LISTAR')) {
            fetchProgramas();
        } else {
            setRedirectTo('/error');
        }
    }, [pagination, filterQuery, sortQuery]);

    const fetchProgramas = () => {
        setLoading(true);
        Utils.getData('/programas-preventivos/grid' + getQuery())
            .then((data) => {
                setProgramas(data.data || []);
                setPaginationCount(data.pagination.count);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    };

    const getQuery = () => {
        let q = '?page=' + pagination.page;
        q += '&perPage=' + pagination.perPage;
        q += '&nombre=' + filterQuery.nombre;
        q += '&estado=' + filterQuery.estado;
        q += '&fechaDesde=' + filterQuery.fechaDesde;
        q += '&fechaHasta=' + filterQuery.fechaHasta;
        q += '&nombreSort=' + sortQuery.nombre;
        q += '&fechaInicioSort=' + sortQuery.fechaInicio;
        q += '&updatedAtSort=' + sortQuery.updatedAt;
        return q;
    };

    const requestSort = (key) => {
        let query = { nombre: '', fechaInicio: '', updatedAt: '' };
        let prev = sortQuery[key];
        query[key] = !prev ? 'asc' : prev === 'asc' ? 'desc' : 'asc';
        setSortQuery(query);
        setPagination((prev) => ({ ...prev, page: 0 }));
    };

    const sortIcon = (key) => {
        if (!sortQuery[key]) return Sort;
        return sortQuery[key] === 'asc' ? SortAsc : SortDesc;
    };

    const handleFilterChange = (query) => {
        setFilterQuery(query);
        setPagination((prev) => ({ ...prev, page: 0 }));
    };

    return (
        <>
            {redirectTo && <Redirect push to={redirectTo} />}
            <div className="card">
                <div className="card-content collpase show">
                    <div className="card-body card-dashboard">
                        <div className="container-fluid mb-1">
                            <div className="row dt-icons">
                                <div className="col">
                                    {Security.hasPermission('PROGRAMAS_PREVENTIVOS_CREAR') && (
                                        <div
                                            className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                                            style={{ height: 55 }}
                                            onClick={() => props.history.push(props.match.url + '/add')}
                                        >
                                            <i className="ft-plus"></i>
                                        </div>
                                    )}
                                    <div
                                        className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                                        style={{ height: 52 }}
                                        onClick={() => setDropdownActive(!dropdownActive)}
                                    >
                                        {dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
                                    </div>
                                </div>
                                <div className="col"></div>
                            </div>
                        </div>

                        <ProgramasPreventivosGridFiltros
                            dropdownActive={dropdownActive}
                            setDropdownActive={setDropdownActive}
                            filterQuery={filterQuery}
                            setFilterQuery={handleFilterChange}
                            filterResetInputs={filterResetInputs}
                            setFilterResetInputs={setFilterResetInputs}
                        />

                        <TableContainer>
                            <Table aria-label="programas-preventivos table" className="table-hover">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell
                                            align="left"
                                            onClick={() => requestSort('nombre')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <FormattedMessage id="programasPreventivosGrid.column_nombre" defaultMessage="Nombre" />
                                            <img className="ml-1" src={sortIcon('nombre')} alt="sort" style={{ height: '12px', width: '22px' }} />
                                        </StyledTableCell>
                                        <StyledTableCell
                                            align="left"
                                            onClick={() => requestSort('fechaInicio')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <FormattedMessage id="programasPreventivosGrid.column_periodo" defaultMessage="Período" />
                                            <img className="ml-1" src={sortIcon('fechaInicio')} alt="sort" style={{ height: '12px', width: '22px' }} />
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            <FormattedMessage id="programasPreventivosGrid.column_estado" defaultMessage="Estado" />
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <FormattedMessage id="programasPreventivosGrid.column_incluidos" defaultMessage="Incluidos" />
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <FormattedMessage id="programasPreventivosGrid.column_excluidos" defaultMessage="Excluidos" />
                                        </StyledTableCell>
                                        <StyledTableCell
                                            align="left"
                                            onClick={() => requestSort('updatedAt')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <FormattedMessage id="programasPreventivosGrid.column_modificacion" defaultMessage="Última modificación" />
                                            <img className="ml-1" src={sortIcon('updatedAt')} alt="sort" style={{ height: '12px', width: '22px' }} />
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <FormattedMessage id="programasPreventivosGrid.column_acciones" defaultMessage="Acciones" />
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {loading ? (
                                        <TableRow>
                                            <StyledTableCell colSpan={6} align="center" style={{ padding: '40px' }}>
                                                <CircularProgress />
                                            </StyledTableCell>
                                        </TableRow>
                                    ) : programas.length === 0 ? (
                                        <TableRow>
                                            <StyledTableCell colSpan={6} align="center" style={{ padding: '40px', color: '#999' }}>
                                                <FormattedMessage
                                                    id="programasPreventivosGrid.empty_state"
                                                    defaultMessage="No hay programas de mantenimiento preventivo."
                                                />
                                            </StyledTableCell>
                                        </TableRow>
                                    ) : (
                                        programas.map((p) => (
                                            <ProgramasPreventivosGridRow
                                                key={p.id}
                                                programa={p}
                                                baseUrl={props.match && props.match.url}
                                                permissions={permissions}
                                                fetchProgramas={fetchProgramas}
                                            />
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            component="div"
                            count={paginationCount}
                            rowsPerPage={pagination.perPage}
                            page={pagination.page}
                            onChangePage={(e, newPage) => setPagination((prev) => ({ ...prev, page: newPage }))}
                            onChangeRowsPerPage={(e) =>
                                setPagination({ page: 0, perPage: parseInt(e.target.value, 10) })
                            }
                            labelRowsPerPage={intl.formatMessage({
                                id: 'programasPreventivosGrid.pagination.rows_per_page',
                                defaultMessage: 'Filas por página',
                            })}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProgramasPreventivosGrid;
